/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type MediaType = typeof MediaType[keyof typeof MediaType];


export const MediaType = {
  UNKNOWN: 'UNKNOWN',
  CALL: 'CALL',
  BUSINESSOBJECT: 'BUSINESSOBJECT',
} as const;
